<template>
  <div class="shadow-md p-3 font-primary">
    <b>Pedidos del Cliente: {{ cliente.razonSocial }}</b> <br>
    <div v-show="pedHistoricos" class="h-[60vh] overflow-y-scroll">
      <table class="table table-striped table-sm text-sm">
        <thead>
          <tr>
            <th scope="col">Nro WEB</th>
            <th scope="col">Nro Pedido</th>
            <th scope="col">Direccion</th>
            <th scope="col">Fecha</th>
            <th scope="col">Cliente</th>
            <th scope="col">Total</th>
            <th scope="col">Cant. items</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody v-if="pedHistoricos.length > 0">
          <tr v-for="(ped, key) in pedHistoricos" class="px-0" :key="key">
            <td>{{ ped.IDCON_PED }}</td>
            <td>{{ ped.NUMERO_PED }}</td>
            <td>{{ ped.DIRECCION_PED }}</td>
            <td>{{ formatDate(ped.FECHA_CARGA_PED) }}</td>
            <td>{{ ped.razon }}</td>
            <td>{{ ped.IMPORTE_CP.toFixed(2) }}</td>
            <td>{{ ped.items.length }}</td>
            <td><button class="btn btn-outline-primary btn-sm" @click="verItems(ped.items)">Ver Items</button></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td>No hay pedidos aun..</td>
          </tr>
        </tbody>
      </table>
    </div>



    <div class="modal" id="itemsPed">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          
          <!-- Modal Header -->
          <div class="modal-header">
              <h4 class="modal-title">Items del pedido</h4>
          </div>
          
          <!-- Modal body -->
          <div class="modal-body">
            <table class="table table-striped table-sm text-sm">
              <thead>
                <tr>
                  <th scope="col">Codigo</th>
                  <th scope="col">Descripcion</th>
                  <th scope="col">Precio unitario</th>
                  <th scope="col">cantidad</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in items" class="px-0" :key="key">
                  <td>{{ item.CODIGO_ART }}</td>
                  <td>{{ item.DESCRIP_ART }}</td>
                  <td>${{ item.PRECIO_LPI.toFixed(2) }}</td>
                  <td>{{ item.CANTIDAD_PEDI }}</td>
                  <td>${{ (Number(item.PRECIO_LPI) * Number(item.CANTIDAD_PEDI)).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        
          <!-- Modal footer -->
          <div class="modal-footer">
              <button class="btn btn-danger bg-truered" data-bs-dismiss="modal">Cancelar</button>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>

<script>
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';
export default {
  data() {
    return {
      pedHistoricos: [],
      items: [],
      id: '',
      cliente: ''
    };
  },
  mounted() {
      this.id = this.$route.params.user;
      this.getCliente()
  },
  methods: {
      verItems(items) {
          this.items = items
          window.$('#itemsPed').modal('show')
      },
      getCliente() {
        usuarioService.getUserId(this.id)
          .then((res) => {
            this.cliente = res.data
            this.getMisPedidos()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getMisPedidos() {
          pedidosService.getPedidosUsuario(this.cliente.idcli)
              .then((res) => {
                  console.log(res.data)
                  this.pedHistoricos = res.data
              })
              .catch((err) => {
                  console.log(err)
              })
      },
      formatDate(dateString) {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
      }
  },
  computed: {
  },
};
</script>

